export default __webpack_public_path__ + "static/media/iata.36df9429.png";